import React from "react";

type Props = {
  title: string;
  value: number;
  discount?: number;
} & React.InputHTMLAttributes<HTMLInputElement>;

const PlanInput: React.FC<Props> = ({
  title,
  value,
  discount,
}): JSX.Element => {
  const calculateValue = () => {
    if (value && !discount) {
      return parseFloat(
        value
          .toString()
          .slice(0, -2)
          .concat(`.${value.toString().slice(-2)}`)
      ).toFixed(2);
    }
    if (value && discount) {
      let newValue = value - discount;
      return parseFloat(
        newValue
          .toString()
          .slice(0, -2)
          .concat(`.${newValue.toString().slice(-2)}`)
      ).toFixed(2);
    }

    return "";
  };

  return (
    <div
      className="flex flex-col h-36"
      style={{
        boxSizing: "border-box",
        background: "#FFFFFF",
        border: "1px solid #D6D6D6",
        borderRadius: "8px",
      }}
    >
      <div className="flex flex-row border-b h-16 ml-3 justify-between items-center">
        <div className="flex flex-col">
          <div
            className="font-sora text-base"
            style={{
              fontStyle: "normal",
              fontWeight: 400,
              color: "#4F4F4F",
            }}
          >
            {title}
          </div>
        </div>
      </div>
      <div className="flex flex-row h-24 items-center">
        <div
          className="flex flex-col w-2/3 ml-3 font-sora text-base"
          style={{
            fontStyle: "normal",
            fontWeight: 400,
            color: "#4F4F4F",
          }}
        >
          Price
        </div>
        <div className="flex flex-col w-2/3 h-16 mr-6 border border-bt-light-gray rounded">
          <div
            className="mt-4 mr-2"
            style={{
              textAlign: "right",
            }}
          >
            <span
              className="text-bt-green text-xl font-sora"
              style={{
                fontStyle: "normal",
                fontWeight: 600,
              }}
            >
              {calculateValue()}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanInput;
